import i18n from "i18next";
import { initReactI18next } from "react-i18next";
//import HttpApi from 'i18next-http-backend';
import resources from "./locales";

//const backend = {
//    loadPath: '/locales/{{lng}}/{{ns}}.json',
//    //request: function (options, url, payload, callback) {
//    //    console.log({options, url, payload, callback});
//    //},
//}

i18n
    //    .use(HttpApi)
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
        lng: process.env.REACT_APP_DEFAULT_LANGUAGE,
        resources,
        //backend,
        //keySeparator: false, // we do not use keys in form messages.welcome

        interpolation: {
            escapeValue: false // react already safes from xss
        },
        debug: process.env.NODE_ENV === "development"
    });

export default i18n;
